import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const reactPlugin = new ReactPlugin();

// process.env.REACT_APP_X is only inlined at build time when it appears as a
// literal, so this must not be built dynamically.
const connectionString =
  process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

export function initAppInsights() {
  // Telemetry is non-essential: absent config is a no-op, never a throw.
  if (!connectionString || typeof window === 'undefined') return null;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      enableCorsCorrelation: false,
      disableCookiesUsage: true,
      loggingLevelConsole: 0,
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {};
    envelope.tags['ai.cloud.role'] = 'everify-dashboard-uat';
  });

  appInsights.trackPageView();
  return appInsights;
}

export const getAppInsights = () => appInsights;
